import { render, staticRenderFns } from "./sfc-header-no-nav.vue?vue&type=template&id=80a067b8&scoped=true&lang=pug&"
import script from "./sfc-header-no-nav.vue?vue&type=script&lang=js&"
export * from "./sfc-header-no-nav.vue?vue&type=script&lang=js&"
import style0 from "./sfc-header-no-nav.vue?vue&type=style&index=0&id=80a067b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a067b8",
  null
  
)

export default component.exports